import React from "react";
import "./mobile-nav.css";
import { Icon } from "@/components/ui-components/icon";
import { useAuthStore } from "@/app/state/auth-store";
import type { InterpolationValues } from "@/i18n/types";

interface Props {
    cartCount: number;
    t: (key: string, values?: InterpolationValues) => string;
    activeItem: "home" | "categories";
    onHome: () => void;
    onCategories: () => void;
    onSearch: () => void;
    onMenu: () => void;
    onCart: () => void;
}

export function MobileNav({ cartCount, t, activeItem, onHome, onCategories, onSearch, onMenu, onCart }: Props) {
    const user = useAuthStore(state => state.user);
    return (
        <nav className={`mobile-nav${user ? " mobile-nav--with-cart" : ""}`} aria-label={t("layout.mobileNav.menu")}>
            <button className={activeItem === "home" ? "active" : undefined} type="button" aria-current={activeItem === "home" ? "page" : undefined} onClick={onHome}><Icon name="home" /><small>{t("layout.mobileNav.home")}</small></button>
            <button className={activeItem === "categories" ? "active" : undefined} type="button" aria-current={activeItem === "categories" ? "page" : undefined} onClick={onCategories}><Icon name="grid" /><small>{t("layout.mobileNav.categories")}</small></button>
            <button type="button" onClick={onSearch}><Icon name="search" /><small>{t("layout.mobileNav.search")}</small></button>
            <button type="button" onClick={onMenu}><Icon name="menu" /><small>{t("layout.mobileNav.menu")}</small></button>
            {user ? <button type="button" onClick={onCart}><Icon name="cart" /><small>{t("layout.mobileNav.cart")}</small>{cartCount > 0 && <span className="mobile-badge">{cartCount}</span>}</button> : null}
        </nav>
    );
}
